import { Collection } from 'modules/core/lib/mobx-rest'

import ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'

enum ApprovalStatus {
  approved = 'approved',
  rejected = 'rejected',
  pending = 'pending',
  null = '',
}

export class ContractVersionRequests extends Collection<ContractVersionRequest> {
  constructor(data: any = []) {
    super(data)
  }

  get indexes() {
    return ['employee_id', 'effective_on']
  }

  model() {
    return ContractVersionRequest
  }

  async fetchWithApprovalStatusByEmployees(
    employeeIds: number[] = [],
    statuses: ApprovalStatus[] = []
  ): Promise<void> {
    return super.fetch({
      data: { employee_ids: employeeIds, statuses: statuses },
    })
  }

  async fetchWithApprovalStatusByIds(
    ids: number[] = [],
    statuses: ApprovalStatus[] = []
  ): Promise<void> {
    return super.fetch({
      data: { ids: ids, statuses: statuses },
    })
  }
}
